module.exports = __webpack_public_path__ + "static/img/blog_good_11.eb2a8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_11.png
// module id = 6Idn
// module chunks = 8